'use strict';
import angular from 'angular'
import Inputmask from "inputmask";

function FilterController($rootScope, $scope, $filter, $location, $window, objectMakerFactory, dataHolderFactory, onControllerLabelsForLanguageFactory, dataRequestService, usSpinnerService, localStorageService, parameterFactory, parameterNames, appSettings) {
  const self = this;
  let unselect = true;

  this.configureStatusToSend = function(statusArray, uniqueStatus, key) {
    for (let i = 0; i < statusArray.length; i++) {
      if (statusArray[i][key] === uniqueStatus.name) {
        statusArray[i].selected = uniqueStatus.selected;
      }
    }
  };

  this.mountStatusToSend = function(uniqueStatusArray, statusArray) {
    uniqueStatusArray.forEach(function(uniqueStatus) {
      self.configureStatusToSend(statusArray, uniqueStatus, 'name');
    });
  };

  this.selectedSubcategoriesNumber = function(category) {
    return category.subcategories.filter(function(subcategory) {
      return subcategory.selected;
    }).length
  };

  this.configureFilterOptions = function(filters) {
    $scope.filterViewControl.filterOptions = filters;
    const filterOptions = $scope.filterViewControl.filterOptions;

    let inputInitialDate = $('#initial');
    let inputFinalDate = $('#final');

    inputInitialDate.datepicker({ format: 'dd/mm/yyyy', language: 'pt-BR', autoclose: true }).on('hide', function(ev) {
      if (new Date(ev.date.valueOf()) > new Date(filterOptions.period.finalDate)) {
        $('#final').datepicker('update', new Date(ev.date.valueOf()));
        filterOptions.period.initialDate = new Date(ev.date.valueOf());
        return;
      }
      filterOptions.period.initialDate = new Date(ev.date.valueOf())
    });

    inputFinalDate.datepicker({ format: 'dd/mm/yyyy', language: 'pt-BR', autoclose: true }).on('hide', function(ev) {
      if (new Date(ev.date.valueOf()) < new Date(filterOptions.period.initialDate)) {
        $('#initial').datepicker('update', new Date(ev.date.valueOf()));
        filterOptions.period.finalDate = new Date(ev.date.valueOf());
        return;
      }
      filterOptions.period.finalDate = new Date(ev.date.valueOf())
    });

    inputInitialDate.datepicker('update', new Date(filterOptions.period.initialDate));
    inputFinalDate.datepicker('update', new Date(filterOptions.period.finalDate));

    const mask = new Inputmask("99/99/9999");
    inputInitialDate.each((index, element) => mask.mask(element));
    inputFinalDate.each((index, element) => mask.mask(element));
  };

  this.configureSelectorButtonLabel = function(list) {
    for (let i = 0; i < list.length; i++) {
      if (!list[i].selected) {
        unselect = false;
        return onControllerLabelsForLanguageFactory.getLabel('SELECT_ALL');
      }
    }
    unselect = true;
    return onControllerLabelsForLanguageFactory.getLabel('UNSELECT_ALL');
  };

  this.configureListForAllotmentSelection = function(list) {
    angular.forEach(list, function(elem) {
      elem.selected = !unselect;
      if (elem.subcategories) {
        angular.forEach(elem.subcategories, function(subcategory) {
          subcategory.selected = !unselect;
        })
      }
    });
  };

  this.setCategoriesToExpandedState = function(state) {
    angular.forEach($scope.filterViewControl.filterOptions.categories, function(category) {
      category.expanded = state;
    });
  };

  this.configureViewForContracts = function(contracts) {
    contracts.forEach(function(contract) {
      contract.showAddress = false;
      contract.period.initialDate = new Date(parseInt(contract.period.initialDate));
      contract.period.finalDate = new Date(parseInt(contract.period.finalDate));
    });
    dataHolderFactory.updateContracts(contracts);
    dataHolderFactory.updateSortingOptionIndex(0);
    $rootScope.$emit('applyFilters');
    $rootScope.$emit('openViewWithContext', 'CONTRACTS');
  };

  this.initFilterContract = function(){

    var searchObject = $location.search();

    if(searchObject.contrato) {
      var decodedContratoId = $window.atob(searchObject.contrato);

      dataRequestService.getContractDetails(decodedContratoId).then(function (contrato) {

        var initialDate = new Date(contrato.periodValidity.initialDate);
        var finalDate = new Date(contrato.periodValidity.finalDate);

        var filterOptions = $scope.filterViewControl.filterOptions;
        filterOptions.period.initialDate = initialDate;
        filterOptions.period.finalDate = finalDate;
        $scope.applyFilters();

      });
    }
  };

  $scope.initFilterController = function() {
    try {
      $scope.filterViewControl = objectMakerFactory.viewObjectControlForFilter();
      $scope.filterViewControl.activatedSegment = appSettings.config.filter.filtroSelecionado || 'AREA';
      $scope.filterViewControl.showEmpreendimentos = parameterFactory.getParameter(parameterNames.PRM_SHOW_ENTERPRISE).value === "S" ||
        appSettings.config.filter.empreendimentos;
      $scope.filterViewControl.showBensPublicos = parameterFactory.getParameter(parameterNames.PRM_SHOW_CUMMUNITY_ASSERTS).value === "S" ||
        appSettings.config.filter.bensPublicos;

      $scope.filterViewControl.showDocumentos = appSettings.config.filter.documentos;
      $scope.filterViewControl.showOrgaosPublicos = appSettings.config.filter.orgaosPublicos;
      $scope.filterViewControl.showProgramas = appSettings.config.filter.programas;
      $scope.filterViewControl.showSetores = appSettings.config.filter.setores;
      $scope.filterViewControl.showClassificacoes = appSettings.config.filter.classificacoes;
      $scope.filterViewControl.showContratados = appSettings.config.filter.contratados;
      $scope.filterViewControl.showTematicas = appSettings.config.filter.tematicas;
      $scope.filterViewControl.showTiposObras = appSettings.config.filter.tiposObras;
      $scope.filterViewControl.showSituacoes = appSettings.config.filter.situacoes;
      $scope.filterViewControl.showLocalidades = appSettings.config.filter.localidades;

      dataHolderFactory.updateClusteredContracts([]);
      self.configureFilterOptions(dataHolderFactory.getSavedFilterOptions());
      self.setCategoriesToExpandedState(false);
    } catch(e) {
      console.log('[ FAIL ] Failed to init filter: ', e);
    }
  };

  $scope.openDatePicker = function(dataPickerName) {
    $('#' + dataPickerName).datepicker('show');
  };

  $scope.allotmentListSelection = function(context) {
    const filterOptions = $scope.filterViewControl.filterOptions;

    switch (context) {
      case 'AREA':
        return self.configureListForAllotmentSelection(filterOptions.categories);
      case 'PLACES':
        return self.configureListForAllotmentSelection(filterOptions.places);
      case 'COMMUNITYASSETS':
        return self.configureListForAllotmentSelection(filterOptions.communityAssets);
      case 'ORGAN':
        return self.configureListForAllotmentSelection(filterOptions.organs);
      case 'PROGRAM':
        return self.configureListForAllotmentSelection(filterOptions.programs);
      case 'SECTOR':
        return self.configureListForAllotmentSelection(filterOptions.sectors);
      case 'CLASSIFICATION':
        return self.configureListForAllotmentSelection(filterOptions.classifications);
      case 'CONTRACTED':
        return self.configureListForAllotmentSelection(filterOptions.contracteds);
      case 'TEMATICA':
        return self.configureListForAllotmentSelection(filterOptions.tematicas);
      default:
        self.configureListForAllotmentSelection(filterOptions.uniqueStatus);
    }
  };

  $scope.getLabelForAllotmentControlButton = function(context) {
    const filterOptions = $scope.filterViewControl.filterOptions;

    switch (context) {
      case 'AREA':
        return self.configureSelectorButtonLabel(filterOptions.categories);
      case 'PLACES':
        return self.configureSelectorButtonLabel(filterOptions.places);
      case 'COMMUNITYASSETS':
        return self.configureSelectorButtonLabel(filterOptions.communityAssets);
      case 'ORGAN':
        return self.configureSelectorButtonLabel(filterOptions.organs);
      case 'PROGRAM':
        return self.configureSelectorButtonLabel(filterOptions.programs);
      case 'SECTOR':
        return self.configureSelectorButtonLabel(filterOptions.sectors);
      case 'CLASSIFICATION':
        return self.configureSelectorButtonLabel(filterOptions.classifications);
      case 'CONTRACTED':
        return self.configureSelectorButtonLabel(filterOptions.contracteds);
      case 'TEMATICA':
        return self.configureSelectorButtonLabel(filterOptions.tematicas);
      default:
        return self.configureSelectorButtonLabel(filterOptions.uniqueStatus);
    }
  };

  $scope.didSelectedCategory = function(category) {
    category.selected = !category.selected;
    category.subcategories.forEach(function(subcategory) {
      subcategory.selected = category.selected;
    });
  };

  $scope.didSelectedSubcategory = function(category, subcategory) {
    subcategory.selected = !subcategory.selected;
    category.selected = self.selectedSubcategoriesNumber(category) === category.subcategories.length;
  };

  $scope.hasSelectedSubcategories = function(category) {
    return self.selectedSubcategoriesNumber(category) > 0;
  };

  $scope.applyFilters = function() {
    const filterOptions = $scope.filterViewControl.filterOptions;
    self.mountStatusToSend(filterOptions.uniqueStatus, filterOptions.status);
    usSpinnerService.spin('spinner-1');

    dataHolderFactory.updateFavoriteFilterSelected(null);

    dataRequestService
      .getContractsData(objectMakerFactory.viewObjectExtractionForFilter(filterOptions))
      .then(function(contracts) {
        usSpinnerService.stop('spinner-1');
        self.configureViewForContracts(contracts);
      }, function(error) {
        usSpinnerService.stop('spinner-1');
        alert(error.data.error);
      });
  };

  $scope.restoreFilters = function() {
    self.configureFilterOptions(localStorageService.get('originalFilters'));
    dataHolderFactory.updateFilterOptions(localStorageService.get('originalFilters'));
  };

  $rootScope.$on('newFavoriteFilterSelected', function() {
    const filterOptions = dataHolderFactory.getSavedFilterOptions();

    $('#initial').datepicker('update', new Date(filterOptions.period.initialDate));
    $('#final').datepicker('update', new Date(filterOptions.period.finalDate));
  });
}

FilterController.$inject=['$rootScope', '$scope', '$filter', '$location', '$window', 'objectMakerFactory', 'dataHolderFactory', 'onControllerLabelsForLanguageFactory', 'dataRequestService',
  'usSpinnerService', 'localStorageService', 'parameterFactory', 'parameterNames', 'appSettings'];
export default FilterController



// WEBPACK FOOTER //
// ./src/app/scripts/controllers/filterController.js